import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as SpeedIconSvg } from '../../assets/dashboard-icon.svg';

export const SpeedIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={SpeedIconSvg} {...props} />;
};
